import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9abf562a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "携わったことのあるクライアント業種の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "携わったことのあるクライアント業種（複数選択可）")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "careersheet_input"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "その他")
], -1))
const _hoisted_7 = { class: "careersheet_input_layout_column_1" }
const _hoisted_8 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_9 = { class: "careersheet_button" }
const _hoisted_10 = { class: "careersheet_button_prev" }
const _hoisted_11 = { class: "careersheet_button_next" }

import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { ref, computed, Ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import alertOnReload from '@/utils/alertOnReload';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkillBusinesstypeEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const businesstypeList: Ref<{ label: string; value: boolean | null | string; key: string }[]> = ref(
  store.getters['careerSheetBusinesstype/businesstypeList']
);

const businessCheckbox = computed(() => {
  return businesstypeList.value.filter((i) => i.key !== 'otherFieldMemo');
});

const otherFieldFlg = computed(() => {
  return businesstypeList.value.filter((i) => i.key === 'otherFieldFlg')[0].value || false;
});

const schema = object({
  otherFieldMemo: string().label('その他詳細').max(100, VALIDATON_ERRORS.MAX_LENGTH),
});

const { meta, errors } = useForm({
  validationSchema: schema,
});

const { value: otherFieldMemo } = useField('otherFieldMemo', undefined, {
  initialValue: (businesstypeList.value.filter((i) => i.key === 'otherFieldMemo')[0].value || '') as string,
});

const newBusinesstypeList = computed(() => {
  const otherFieldFlg = businesstypeList.value.filter((i) => i.key === 'otherFieldFlg')[0].value || false;
  const res = businesstypeList.value.filter((i) => i.key !== 'otherFieldMemo');
  res.push({
    key: 'otherFieldMemo',
    value: otherFieldFlg && otherFieldMemo.value ? otherFieldMemo.value : '',
    label: 'その他コメント',
  });
  return res;
});

const transitionConfirmPage = () => {
  store.commit('careerSheetBusinesstype/setBusinesstypeList', newBusinesstypeList.value);
  if (route.query.ref === 'e') {
    router.push({ name: 'e62', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e62' });
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e50', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n50' });
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(businessCheckbox), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.label,
          class: "careersheet_input_layout_column_1_item"
        }, [
          _createVNode(BaseCheckbox, {
            value: false,
            label: item.label,
            modelValue: item.value,
            "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
          }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
        ]))
      }), 128))
    ]),
    (_unref(otherFieldFlg))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(BaseTextareaForm, {
                modelValue: _unref(otherFieldMemo),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(otherFieldMemo) ? (otherFieldMemo).value = $event : null)),
                name: "otherFieldMemo",
                rows: 3,
                maxCount: 100,
                placeholder: "その他の場合、詳細を入力してください"
              }, null, 8, ["modelValue"]),
              (_unref(errors).otherFieldMemo)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    errors: [_unref(errors).otherFieldMemo]
                  }, null, 8, ["errors"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          onClick: transitionConfirmPage,
          disabled: !_unref(meta).valid
        }, {
          default: _withCtx(() => [
            _createTextVNode("確認する")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})